import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=6574f313&scoped=true&lang=pug"
import script from "./revenue.vue?vue&type=script&lang=js"
export * from "./revenue.vue?vue&type=script&lang=js"
import style0 from "./revenue.vue?vue&type=style&index=0&id=6574f313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6574f313",
  null
  
)

export default component.exports